<script>
import TablePage from '@/found/components/table_page';
import request from '@/found/utils/request';
import Form from './form/form.vue';
import { ProcessLog } from '../../../../../modules';

export default {
  extends: TablePage,
  components: {
    Form,
    ProcessLog,
  },
  data() {
    return {
      requestType: 'GET',
    };
  },
  mounted() {
    this.getConfigList('remote_code_scanning_report_list');
  },
  methods: {
    // 控制按钮显示
    clickVisible({ row, val: { code } }) {
      const { processNo } = row;
      // 审批通过 approved,审批中 approving,活动关闭 closed,流程追回 interrupt,驳回 rejected
      if (code === 'process_log' && !processNo) {
        return false;
      }
      return true;
    },
    modalClick({ val, row }) {
      if (val.code === 'check_detail') {
        this.formConfig = {
          ...this.formConfig,
          code: 'view',
          row,
        };
        this.modalConfig.title = '查看明细';
        this.openFull();
      } else if (val.code === 'process_log') {
        this.formConfig = {
          ...this.formConfig,
          code: val.code,
          row: { processNo: row.processNo },
        };
        this.modalConfig.title = '流程日志';
        this.formName = 'ProcessLog';
        this.openDrawer();
      }
    },
  },
};
</script>
